(function () {
    'use strict';

    angular
        .module('app.booking')
        .controller('BookingController', BookingController);

    BookingController.$inject = ['$scope', '$q', 'dataservice', 'logger', '$uibModalInstance', 'modalModel', 'vcRecaptchaService', 'translateFilter', '$stateParams', '$analytics'];
    /* @ngInject */
    function BookingController($scope, $q, dataservice, logger, $uibModalInstance, modalModel, vcRecaptchaService,  translateFilter, $stateParams, $analytics) {
        var vm = this;
        vm.responseKey = null;
        vm.widgetId = null;
        vm.key = '6LflOkIUAAAAAHywKymkFP3qML2h5Z0TH5axVJ8S';

        vm.title = 'Booking';
        vm.alert=null;
        vm.data = {};/*from form*/
        vm.reseller = null;
        vm.modalModel = modalModel || {};
        vm.cId = vm.modalModel.cId;
        vm.session = dataservice.login.status;
        vm.isQuickBooking = null;

        vm.options = {};
        vm.cascadeOptions = [];
        vm.cascadeOrder = [];  //

        if(vm.modalModel.formOptions){
            var mode = vm.modalModel.allDayType || 'default';  //default, NA, onRequest,

            if(vm.modalModel.formOptions[mode]){
                vm.cascadeOptions = vm.modalModel.formOptions[mode].cascadeOptions || [];
                vm.cascadeOrder = vm.modalModel.formOptions[mode].cascadeOrder || [];
            }
            //= vm.modalModel.formOptions ? ;
        }

        if(vm.modalModel.minTime){
          vm.modalModel.minTime = newTime(vm.modalModel.minTime);
        }

        if(vm.modalModel.maxTime){
          vm.modalModel.maxTime = newTime(vm.modalModel.maxTime);
        }
        //    [
        //    {value:1, options:[
        //        {value:10, options:[
        //            {value:110, options:[]},
        //            {value:111, options:[]}
        //        ]},
        //        {value:11, options:[
        //            {value:110, options:[]},
        //            {value:111, options:[]}
        //        ]}
        //    ]},
        //    {value:2, options:[
        //        {value:20, options:[
        //            {value:210, options:[]},
        //            {value:211, options:[]}
        //        ]},
        //        {value:21, options:[
        //            {value:210, options:[]},
        //            {value:211, options:[]}
        //        ]}
        //    ]},
        //];
        vm.setResponse = function (response) {
                     console.info('Response available',response);
                     vm.responseKey = response;
                 };
                 vm.setWidgetId = function (widgetId) {
                     console.info('Created widget ID: %s', widgetId);
                     vm.widgetId = widgetId;
                 };
                 vm.cbExpiration = function() {
                     console.info('Captcha expired. Resetting response object');
                     vcRecaptchaService.reload(vm.widgetId);
                    vm.responseKey = null;
                  };
        vm.applyBooking = applyBooking;

        vm.requestBooking = requestBooking;
        vm.addToWaitingList = addToWaitingList;

        vm.getBookingTime = getBookingTime;

        vm.startTimeChanged = startTimeChanged;
        vm.isLoading = false;
        vm.data.today = newTime("00:00");
        activate();

        $scope.$on('obt_recaptcha_created', function(evt) {
            $analytics.eventTrack('BOOKING_CAPTCHA_DISPLAY', {  category: 'captcha', label: vm.modalModel.description || 'booking_description' });
        });

        function getOptions(){
            var options = [{'id': 9, 'name': 'worktypes'}, {'id': 10, 'name': 'therapists'},{'id': 4, 'name': 'locations'}];
            var args ={cId : vm.cId, wq : vm.wq, lq : vm.lq};
            return dataservice.form.getOptions(options, {}, args)
                .then(function(result){
                    vm.options = result;
                });
        }

        function getBookingTime(){
            var start = vm.modalModel.start;
            var end = vm.modalModel.end;
            if(!start || !end){
              return null;
            }

            if(start.isSame(end, 'day')){//check if the event start and end the same day
                return translateFilter('THE') + ' ' +
                    start.format("LL")
                    + ' '+ translateFilter('FROM') + ' ' +
                    start.format("LT")
                    + ' '+translateFilter('TO') + ' ' +
                    end.format("LT"); //'27 Mars 2015 de 1:00 a 2:00';
            }else{
                return translateFilter('FROM_DAY')
                    + ' '+start.format("LL")
                    + ' '+ translateFilter('TO_DAY')
                    + ' '+end.format("LL");
            }
        }

        function isQuickBookingState(){
            return !vm.session || vm.session.reseller ? true : false;
        }
        function activate() {

            vm.isQuickBooking = isQuickBookingState();
            var promises = [getOptions()]; //getBookingInfos()
            return $q.all(promises).then(function() {
                // logger.info('Activated Booking View');
            });
        }

        function requestBooking(){
          console.log('requestBooking');
            return applyBooking('requestBooking');
        }
        function addToWaitingList(){
            return applyBooking('addToWaitingList');
        }
        function applyBooking(mode) {
            startTimeChanged();
            vm.isLoading = true;
            vm.alert=null;
            var args = getBookingData();
            console.log(args,'my args');
            var promise = null;
            if(mode=='requestBooking'){
                promise = dataservice.booking.requestBooking(args, vm.cId);
            }else if(mode=='addToWaitingList'){
                promise = dataservice.booking.addToWaitingList(args, vm.cId);
            }else{
                promise = dataservice.booking.addBooking(args, vm.cId);
            }

            console.debug('applyBooking', args );
            return promise.then(function(data) {
              console.debug('applyBooking response', data );
                    vm.isLoading = false;
                    if (data !== null) {
                        if (data.error === 0 || data.error === 2) {
                            vm.alert = null;
                            $uibModalInstance.close({error: data.error, message: data.body});
                        }else {
                            vm.alert = data.body;
                            // In case of a failed validation you need to reload the captcha because each challenge can be checked just once
                          vcRecaptchaService.reload($scope.widgetId);
                        }
                    } else {
                        vm.alert = 'booking process failed, empty response received!';
                      vcRecaptchaService.reload($scope.widgetId);// In case of a failed validation you need to reload the captcha because each challenge can be checked just once-
                    }
                    return data;
                }, function(data) {
                    vm.isLoading = false;
                    vm.alert =  data || 'booking process failed, empty response received!';
                  vcRecaptchaService.reload($scope.widgetId);// In case of a failed validation you need to reload the captcha because each challenge can be checked just once
                });
        }

        function getBookingData(){
            var args = {};
            console.log(vm.data,'my modalModel');
            //convert to moment if date
            console.log(vm.modalModel,'modelmodel vm');
            var start = vm.modalModel.start && !moment.isMoment(vm.modalModel.start) ? moment(vm.modalModel.start) : vm.modalModel.start;
            var end = vm.modalModel.end && !moment.isMoment(vm.modalModel.end) ? moment(vm.modalModel.end) : vm.modalModel.end;

            if (vm.isQuickBooking) {
                //The user is not logged
                args = {
                    email: vm.data.cEmail,
                    fName: vm.data.fName,
                    lName: vm.data.lName,
                    comment: vm.data.comment,
                    phone :  vm.data.phone,
                    captcha: vm.data.captcha,
                    refName:  vm.data.refName,

                    fullDateStart: start ? start.format() : null, //toUTCString(),
                    fullDateEnd:  end ? end.format() : null, //toUTCString(),
                    therapistId:  vm.modalModel.therapistId,
                    workTypeId:  vm.modalModel.workTypeId,
                    locationId:  vm.modalModel.locationId,
                    shiftlistID:  vm.modalModel.shiftlistID,
                    dayID:  vm.modalModel.dayID,
                   

                    reseller: vm.session ? vm.session.reseller : null,
                    isQuickBooking: vm.isQuickBooking
                };
            } else {
                //User is logged

                args = {
                    email: vm.session.email,
                    sessionId: vm.session.sessionId,

                    comment: vm.data.comment,
                    refName:  vm.data.refName,

                    fullDateStart:  start ? start.format() : null, //.toUTCString(),
                    fullDateEnd: end ?  end.format() : null, //.toUTCString(),
                    therapistId:  vm.modalModel.therapistId,
                    workTypeId:  vm.modalModel.workTypeId,
                    locationId:  vm.modalModel.locationId,
                    shiftlistID:  vm.modalModel.shiftlistID,
                    dayID:  vm.modalModel.dayID,
                    // refName:  vm.modalModel.refName,

                    isQuickBooking: vm.isQuickBooking
                };
            }

            return angular.extend({}, vm.modalModel, args);
        }

        function newTime(timeStr){
          var hours=0, minutes =0, seconds = 0;
          if(timeStr && typeof timeStr == 'string'){
            var splitime = timeStr.split(':');
            if(splitime[0]) hours = splitime[0];
            if(splitime[1]) minutes = splitime[1];
            if(splitime[2]) seconds = splitime[2];
          }

          seconds = seconds ? seconds : 0;
          var time = new Date();
          time.setHours(hours);
          time.setMinutes(minutes);
          time.setSeconds(seconds);
          //this is required, otherwise rollover edges cases tests will have
          //time reset to dates that are off by milliseconds.
          time.setMilliseconds(0);
          return time;
        }

        function startTimeChanged(){
          if(!vm.data.startTime) return;

          if(!vm.modalModel.start){
            vm.modalModel.start = vm.data.startTime;
          }else{
            vm.modalModel.start.setHours(vm.data.startTime.getHours());
            vm.modalModel.start.setMinutes(vm.data.startTime.getMinutes());
            vm.modalModel.start.setSeconds(0);
          }
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/booking/booking.controller.js
 ** module id = 217
 ** module chunks = 0
 **/